module.exports = __webpack_public_path__ + "static/media/car.14ffd3bc.jpg";